import React from "react";
import { LEVELS, BANDS, GOLD } from "@/lib/prime";

export function PrimeLadder({ index, compact = false }) {
  return (
    <ol className={`grid grid-cols-6 gap-1 ${compact ? "" : "sm:gap-2"}`} aria-label="Achievement ladder" data-testid="prime-ladder">
      {LEVELS.map((lv, i) => {
        const here = index === i, past = index !== null && index !== undefined && i < index, prime = lv === "PRIME";
        return (
          <li key={lv} aria-current={here ? "step" : undefined} data-testid={`prime-ladder-${i}`}
            className={`rounded-lg text-center px-1 ${compact ? "py-1" : "py-2"} border transition-colors ${here ? "border-transparent text-white shadow-md" : past ? "border-[#0D9488]/30 bg-[#0D9488]/10 text-[#0F5E59]" : "border-slate-200 bg-white text-slate-500"}`}
            style={here ? { background: prime ? GOLD : "#006090" } : undefined}>
            <span className={`block font-bold leading-tight ${compact ? "text-[10px]" : "text-[10px] sm:text-sm"}`}>{lv.replace(" Star", "★")}<span className="sr-only">{lv.includes("Star") ? " Star" : ""}</span></span>
            {!compact && <span className="hidden sm:block text-[10px] opacity-80">{BANDS[lv]}</span>}
            {here && <span className="sr-only"> — current level</span>}
          </li>
        );
      })}
    </ol>
  );
}
